import { Controller } from "@hotwired/stimulus"

// Copies a candidate's agent_config as raw Markdown to the clipboard. It fetches the
// raw source endpoint rather than reading the rendered HTML, so the copied bytes stay
// byte-identical to what the candidate submitted (fenced code, headings, smart quotes).
// Feedback swaps the leading icon to a check (or tints the button on failure) and
// announces via aria-live — the button's text label never changes, so there is no
// layout shift. The fetch is the single source of truth — never copy a login redirect
// or an HTML body.
export default class extends Controller {
  static values = { url: String }
  static targets = ["copyIcon", "doneIcon", "status"]

  async copy() {
    try {
      const response = await fetch(this.urlValue, { credentials: "same-origin" })
      if (!response.ok || response.redirected) return this.failed()
      const contentType = response.headers.get("Content-Type") || ""
      if (!contentType.includes("text/markdown")) return this.failed()
      await navigator.clipboard.writeText(await response.text())
      this.succeeded()
    } catch {
      this.failed()
    }
  }

  succeeded() {
    this.copyIconTarget.classList.add("hidden")
    this.doneIconTarget.classList.remove("hidden")
    this.announce("Copied to clipboard")
    this.resetAfterDelay(() => {
      this.doneIconTarget.classList.add("hidden")
      this.copyIconTarget.classList.remove("hidden")
    })
  }

  failed() {
    this.element.classList.add("border-destructive", "text-destructive")
    this.announce("Copy failed")
    this.resetAfterDelay(() => {
      this.element.classList.remove("border-destructive", "text-destructive")
    })
  }

  announce(message) {
    if (this.hasStatusTarget) this.statusTarget.textContent = message
  }

  resetAfterDelay(reset) {
    clearTimeout(this.resetTimer)
    this.resetTimer = setTimeout(() => {
      reset()
      this.announce("")
    }, 1500)
  }
}
